import React from 'react'
import {getExperienceId} from '../ExperiencesApp/ExperiencesApp'
import {connect} from 'react-redux'
import {Details} from './Details'
import {GuideBlock} from './GuideBlock'
import {Routes} from '../RoutesPage/Routes'
import {Publish} from './Publish'
import {Share} from './Share'
import {experienceActions, experienceSelectors} from 'data/resources/experiences'
import {Stats} from './Stats'
import {Messages} from './Messages'
import {ColWrap, MainCol, SecondaryCol} from 'common/layouts/SideNavLayout/TwoCol'
import Helmet from 'react-helmet'

export class _Overview extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      lastPackageLoaded: false
    }
  }

  componentDidMount () {
    this.loadData()
  }

  componentDidUpdate (prevProps) {
    if (getExperienceId(prevProps) !== getExperienceId(this.props)) {
      this.loadData()
    }
  }

  loadData () {
    this.setState({lastPackageLoaded: false})
    this.props.loadExperience()
    this.props.loadLastPackage()
      .then(() => {
        this.setState({lastPackageLoaded: true})
      })
      .catch((error) => {
        if (error.details.length > 0 && error.details[0].error_code === 'not_found') {
          // the experience has never been published
          this.setState({lastPackageLoaded: true})
        }
      })
  }

  render () {
    const {experience, lastPackage, hasUpdates, allowMessaging} = this.props
    const {lastPackageLoaded} = this.state

    if (!experience || !lastPackageLoaded) return <div />

    return (
      <ColWrap>
        {experience && <Helmet title={experience.name} />}
        <MainCol>
          <Details experience={experience} />
          <Routes experience={experience} preview editable />
          <GuideBlock experience={experience} />
        </MainCol>
        <SecondaryCol>
          <Publish lastPackage={lastPackage} hasUpdates={hasUpdates} experience={experience} />
          <Share isPublished={lastPackage && lastPackage.packageFileSize && experience.active} experience={experience} />
          <Stats experience={experience} />
          {allowMessaging && <Messages experience={experience} />}
        </SecondaryCol>
      </ColWrap>
    )
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const experienceId = getExperienceId(ownProps)
  return {
    loadExperience: () => dispatch(experienceActions.read(experienceId)),
    loadLastPackage: () => dispatch(experienceActions.lastPackage(experienceId))
  }
}

const mapStateToProps = (state, ownProps) => {
  const id = getExperienceId(ownProps)
  return {
    experience: experienceSelectors.find(state, id),
    lastPackage: experienceSelectors.lastPackage(state, id),
    hasUpdates: experienceSelectors.hasUpdates(state, id),
    allowMessaging: experienceSelectors.allowMessaging(state, id)
  }
}

export const Overview = connect(
  mapStateToProps,
  mapDispatchToProps
)(_Overview)
